<template lang="pug">
  #program-reports-admin-super
    .card-content
      BCollapse.card(
        aria-id="programOverviewCollapse"
        :open.sync="programsTableOpen"
      )
        .card-header(
          slot='trigger',
          role='button',
          aria-controls='programOverviewCollapse'
        )
          .card-header-title
            WtTitle(card-title) Program Overview Report
          a.card-header-icon
            BIcon(:icon="programsTableOpen ? 'chevron-up mdi-48px' : 'chevron-down mdi-48px'")
        .card-content
          .card.has-background-light
            .card-content
              .content
                WtTile(ancestor)
                  WtTile(parent :col="3")
                    WtTile(child :is-loading="programAggregateLoading")
                      .level
                        .level-item
                          BTooltip(
                            :label="activeProgramsText"
                            dashed
                            animated
                            size="is-small"
                            type="is-dark"
                            :multilined="true"
                          ) Active Programs
                      .level
                        WtTitle.level-item(h1) {{ allProgramAggregate.activeProgramCount }}
                  WtTile(parent)
                    WtTile(child :is-loading="programAggregateLoading")
                      .level
                        .level-item
                          BTooltip(
                            :label="memberCountText"
                            dashed
                            animated
                            size="is-small"
                            type="is-dark"
                            :multilined="true"
                          ) Total Members
                      .level
                        WtTitle.level-item(h1) {{ allProgramAggregate.allMemberCount }}

          .card
            .card-header
              .card-header-title
                span Programs
            .card-content
              AdminSuperProgramsTable
</template>

<script>
import { mapActions } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import { numberUtilityMixin } from "@/mixins/numberUtilityMixin";

const AdminSuperProgramsTable = () =>
  import(
    /* webpackChunkName: "AdminSuperProgramsTable" */ "@/components/AdminSuperPrograms/AdminSuperProgramsTable.vue"
  ).catch(() => {
    window.location.reload();
  });

export default {
  name: "ProgramReportsAdminSuper",

  components: { AdminSuperProgramsTable, WtTitle, WtTile },

  mixins: [numberUtilityMixin],

  data() {
    return {
      programs: {},
      programsLoading: false,
      allProgramAggregate: {},
      programAggregateLoading: false,
      programsTableOpen: true,
      activeProgramsText: `Count of currently active programs in the new UI.`,
      memberCountText: `Total of all members for programs in the new UI.`
    };
  },

  async mounted() {
    this.fetchAggregate();
    this.fetchPrograms();

    this.onSearch = this._.debounce(async query => {
      this.programsLoading = true;
      this.programs = await this.searchPrograms(query);
      this.programsLoading = false;
    }, 500);
  },

  methods: {
    ...mapActions("program", [
      "fetchAll",
      "searchPrograms",
      "fetchAllProgramAggregate"
    ]),

    async fetchPrograms(payload) {
      this.programsLoading = true;
      this.programs = await this.fetchAll({ ...payload });
      this.programsLoading = false;
    },

    async fetchAggregate() {
      this.programAggregateLoading = true;
      this.allProgramAggregate = await this.fetchAllProgramAggregate();
      this.programAggregateLoading = false;
    },

    onSearch() {
      // defining this here, but is overwritten in the
      // mounted call.  Using debounce requires this
      // approach in order for it to work when
      // the component instance is available.
    }
  }
};
</script>

<style scoped></style>
